// Facebook / Meta Pixel helper
// Uses the standard fbq snippet so we don't depend on package-specific exports.

const PIXEL_ID = '911502815354887'

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[]
      push?: unknown
      loaded?: boolean
      version?: string
    }
    _fbq?: unknown
  }
}

let initialized = false

export function initPixel() {
  if (initialized || typeof window === 'undefined')
    return // Standard Meta Pixel base code
  ;(function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      // eslint-disable-next-line prefer-rest-params
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    s?.parentNode?.insertBefore(t, s)
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )

  try {
    window.fbq?.('init', PIXEL_ID)
    initialized = true
  } catch (err) {
    console.error('Meta Pixel init failed', err)
  }
}

export function trackPageView() {
  if (typeof window === 'undefined') return
  if (!initialized) initPixel()
  try {
    window.fbq?.('track', 'PageView')
  } catch (err) {
    console.error('Meta Pixel PageView failed', err)
  }
}

export function trackAddToCart(label?: string) {
  if (typeof window === 'undefined') return
  if (!initialized) initPixel()
  try {
    window.fbq?.(
      'track',
      'AddToCart',
      label ? { content_name: label } : undefined,
    )
  } catch (err) {
    console.error('Meta Pixel AddToCart failed', err)
  }
}
